import React from "react";

function BoxTitle({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <h3
      className={`text-[length:var(--font-subtitle)] leading-[var(--font-subtitle-height)] text-[var(--primary)] font-medium m-0 ml-[0.8rem] ${className ?? ""}`}
      data-cy={"box-title"}
    >
      {children}
    </h3>
  );
}

function BoxSubTitle({ children, className }: { children: React.ReactNode; className?: string }) {
  return <p className={`text-[13px] font-normal leading-6 ${className ?? ""}`}>{children}</p>;
}

export { BoxTitle, BoxSubTitle };
